import React from 'react'
import Helmet from 'react-helmet'
import PageWrapper from '../components/PageWrapper/PageWrapper'
import TextContainer from '../components/TextContainer/TextContainer'
import Inner from '../components/Inner/Inner'
import Divider from '../components/Divider/Divider'
import Careers from '../components/Careers/Careers'
import styles from './AboutPage.module.css'

const AboutPage = props => {
  function createContent() {
    return {
      __html: props.data.about.edges[0].node.childMarkdownRemark.html,
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.overlay} />
      <Helmet
        title="About - Dominion Systems, LLC"
        meta={[
          {
            name: 'description',
            content:
              'Dominion Systems was established in 1989 and is locally owned and operated. We have extended our services to customers in 37 states and 5 countries.',
          },
        ]}
      />
      <PageWrapper>
        <Inner>
          <div className={styles.grid}>
            <div className={styles.body}>
              <TextContainer>
                <h1>About Dominion Systems</h1>
                <Divider />
                <div dangerouslySetInnerHTML={createContent()} />
              </TextContainer>
            </div>
            <div className={styles.teamWrapper}>
              <TextContainer>
                <h2 className={styles.team}>Meet The Team</h2>
                <Divider />
              </TextContainer>
              <div className={styles.people}>
                {props.data.team.edges.map(person => (
                  <div
                    key={person.node.childMarkdownRemark.frontmatter.title}
                    className={styles.person}
                  >
                    <h3>{person.node.childMarkdownRemark.frontmatter.title}</h3>
                    <p className={styles.position}>
                      {person.node.childMarkdownRemark.frontmatter.position}
                    </p>
                    <p className={styles.meta}>
                      {person.node.childMarkdownRemark.frontmatter.phone}
                      <br />
                      <a
                        href={`mailto:${
                          person.node.childMarkdownRemark.frontmatter.email
                        }`}
                      >
                        Email
                      </a>
                    </p>
                  </div>
                ))}
              </div>
              <TextContainer>
                <Careers />
              </TextContainer>
            </div>
          </div>
        </Inner>
      </PageWrapper>
    </div>
  )
}

export default AboutPage

export const aboutQuery = graphql`
  query aboutQuery {
    about: allFile(filter: { sourceInstanceName: { eq: "about" } }) {
      edges {
        node {
          childMarkdownRemark {
            html
            frontmatter {
              title
            }
          }
        }
      }
    }
    team: allFile(filter: { sourceInstanceName: { eq: "team" } }) {
      edges {
        node {
          childMarkdownRemark {
            html
            frontmatter {
              title
              position
              email
              phone
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/about.js